@if (email()) {
  <stripe-pricing-table
    [attr.pricing-table-id]="pricingTableId"
    [attr.publishable-key]="publishableKey"
    [attr.customer-email]="email()">
  </stripe-pricing-table>
}
@else {
  User email is required to subscribe.
}
